import React, {Component} from 'react'

export default class Logo extends Component {
  render(){
    return (
      <div className="LogoBlock">
        <img
          src="https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/10194925/logo.png"
          alt="" title="logo" style={{height: '100%'}}/>
      </div>
    )
  }
}